import cn from 'classnames';
import PropTypes from 'prop-types';
import LillyLogoSvg from './LillyLogoSvg.jsx';

import {
  getValidSizeClass
} from './lillyLogo.helpers.js';

// JSDoc type definitions
/**
 * @typedef LdsLillyLogoProps
 * @property {any} [size] - The "T-Shirt" size of the logo; Accepts: "xs", "sm", "md", "lg", "xl", or "fit"
 * @property {string} [color] - Fill color of the logo SVG; Accepts: "red", "white", or "black"; red is the offical "Lilly Red" brand color.
 * @property {string} [className] - Optional custom user-defined CSS class names, will be appended to the list of any other component classes
 * @property {string} [link] - The HREF URL that the built in hyperlink feature should link to; must be Lilly.com or a regional Lilly corporate affiliate website.
 * @property {string} [ariaLabel] - A String value which sets the ARIA label attribute for the built-in hyperlink when enabled
 * @property {boolean} [removeLink] - Whether the built-in hyperlink feature should be disabled
 * @property {string} [title] - A String value which sets the title tag of the logo SVG
 */
/**
 * LdsLillyLogo component
 * @param {React.InputHTMLAttributes<HTMLInputElement> & LdsLillyLogoProps} props
 * @returns {React.JSX.Element}
 */
function LdsLillyLogo({
  size = 'lg',
  color = 'red',
  className = '',
  link = 'https://www.lilly.com',
  ariaLabel = 'Visit Lilly.com',
  removeLink = false,
  title = 'Lilly',
  ...rest
}) {
  const elementClasses = cn(
    'lds-lilly-logo',
    getValidSizeClass(size),
    className
  );

  if (removeLink) {
    return (
      <div
        className={elementClasses}
        {...rest}
      >
        <LillyLogoSvg color={color} title={title} />
      </div>
    );
  }

  return (
    <a
      href={link}
      className={elementClasses}
      aria-label={ariaLabel}
      {...rest}
    >
      <LillyLogoSvg color={color} title={title} />
    </a>
  );
}

export default LdsLillyLogo;

LdsLillyLogo.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'fit']),
  color: PropTypes.oneOf(['red', 'white', 'black']),
  className: PropTypes.string,
  link: PropTypes.string,
  ariaLabel: PropTypes.string,
  removeLink: PropTypes.bool,
  title: PropTypes.string,
};
